import React from 'react';
import { BaseGrid } from '../../components/visualizations/grids/base-grid';
import { useAppPrintMode } from '../../../print';
import { useRecoilValue } from 'recoil';
import { isReportState } from 'venn-state';
import { useTopHoldings } from './logic/useTopHoldings';
import { useTopHoldingsTable } from './logic/useTopHoldingsTable';
import { StyledErrorState } from '../../../studio-blocks/components/StyledErrorState';
import type { TopHoldingsDataResponse } from 'venn-api';

export const TopHoldingsContent = ({ id }: { id: string }) => {
  const holdingsResult = useTopHoldings(id);

  if (holdingsResult.state === 'ERROR') {
    return <StyledErrorState selectedRefId={id} header={holdingsResult.error ?? 'An unknown error occurred'} />;
  }

  const { data } = holdingsResult;

  if (!data.topHoldings[0]?.holdings.length) {
    return <StyledErrorState selectedRefId={id} header="No top holdings found" />;
  }

  return <Grid id={id} data={data} />;
};

const Grid = ({ id, data }: { id: string; data: TopHoldingsDataResponse }) => {
  const { inPrintModeOrReportLab } = useAppPrintMode();
  const isReport = useRecoilValue(isReportState);

  const { rowData, columnDefs, pinnedBottomRowData } = useTopHoldingsTable(id, data);

  return (
    <BaseGrid
      selectedRefId={id}
      inPrintMode={inPrintModeOrReportLab}
      rowData={rowData}
      columnDefs={columnDefs}
      isReport={isReport}
      exportable={false}
      isCompact={false}
      pinnedBottomRowData={pinnedBottomRowData}
    />
  );
};
